class BundleBasketBar extends HTMLElement {
  constructor() {
    super();
    this.addToCartHandle = this.addToCartHandle.bind(this);
    this.stickyBar = this.stickyBar.bind(this);
    this.cart = document.querySelector('cart-drawer');
    this.initBundleBasketBar();
    this.initialBasketBarTop = null;
  }

  /**
   * Initialize basket bar.
   */
  initBundleBasketBar() {
    this.price = document.querySelector('[js-basket-bar="total-price"]');
    this.addToCart = document.querySelector('[js-basket-bar="add-to-cart"]');
    this.addToBundle = document.querySelectorAll('[js-bundle-drawer="add-to-cart"]');
    this.collectionHandle = document
      .querySelector('[js-bundle-tracker="container"]')
      .getAttribute('data-bundle-handle');

    this.updateTotalPriceDisplay();
    this.addToCart.addEventListener('click', this.addToCartHandle);
    this.addToBundle.forEach((button) => button.addEventListener('click', () => this.updateTotalPriceDisplay()));
    window.addEventListener('scroll', this.stickyBar);
    document.addEventListener('DOMContentLoaded', () => {
      this.initialBasketBarTop = document.querySelector('[js-bundle-basket-bar="container"]').offsetTop;
    });
  }

  /**
   * Calculate total price of added products.
   * @returns {number}
   */
  calculateTotalPrice() {
    let totalPrice = 0;

    (JSON.parse(localStorage.getItem(`bundleProducts_${this.collectionHandle}`)) || []).forEach((product) => {
      totalPrice += parseFloat(product.price.replace(/[^\d.-]/g, '')) * parseInt(product.quantity, 10);
    });

    return totalPrice;
  }

  /**
   * Update basket total price.
   */
  updateTotalPriceDisplay() {
    if (!this.price) {
      return;
    }

    const totalPrice = this.calculateTotalPrice().toFixed(2);
    this.price.innerHTML = `${window.bundleDrawerStrings.moneyFormat}${totalPrice}`;

    if (Number(totalPrice) === 0) {
      this.clearDiscount();
    }
    this.updateDiscountItem(totalPrice);
  }

  /**
   * Add to cart handle.
   */
  async addToCartHandle() {
    const products = JSON.parse(localStorage.getItem(`bundleProducts_${this.collectionHandle}`)) || [];

    if (!products.length) {
      return;
    }

    const formData = {
      items: [],
      sections: ['cart-notification-product', 'cart-notification-button', 'cart-icon-bubble', 'cart-drawer']
    };

    products.forEach((product) => {
      formData.items.push({
        id: product.selectedVariant,
        quantity: product.quantity
      });
    });

    const config = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    };

    try {
      fetch(`${routes.cart_add_url}.js`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'product-form',
              cartData: response,
              errors: response.errors || response.description,
              message: response.message
            });
            this.handleErrorMessage(response.message);
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          if (!this.error) {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'product-form',
              cartData: response
            });
          }
          this.error = false;
          this.cart.renderContents(response);
          this.clearBundleTracker();
          formData.items = [];
        })
        .catch((err) => {
          throw new Error(err);
        });
    } catch (err) {
      throw new Error(err);
    }
  }

  handleErrorMessage(errorMessage = false) {
    document.querySelector('[js-basket-bar="error-container"]').innerHTML = errorMessage;
    document.querySelector('[js-basket-bar="error"]').classList.toggle('hidden');
  }

  /**
   * Clear bundle tracker.
   */
  clearBundleTracker() {
    const items = document.querySelectorAll('[js-bundle-tracker="item"]');

    if (!items) {
      return;
    }

    items.forEach((item) => {
      const bundleProduct = item.querySelector('[js-bundle-tracker="item-product"]');
      const placeHolderIcon = item.querySelector('[js-bundle-tracker="item-icon"]');

      bundleProduct.parentNode.remove();
      const target = document.querySelector('.bundle-tracker__wrapper'),
          div = document.createElement('div');
      div.classList.add('bundle-tracker__item-placeholder', 'swiper-slide');
      div.setAttribute('js-bundle-tracker', 'item-placeholder');
      div.innerHTML = `
          <span  class="bundle-tracker__item-icon" js-bundle-tracker="item-icon">
            ${window.bundleDrawerStrings.placeholderIcon}
          </span>
        `;
      target.appendChild(div);
      window.dispatchEvent(new Event('resize'));
    });

    localStorage.removeItem(`bundleProducts_${this.collectionHandle}`);
    localStorage.removeItem(`bundleWrapperHTML_${this.collectionHandle}`);
    this.updateTotalPriceDisplay();
    this.clearDiscount();
  }

  /**
   * Update discount item tracker.
   * @param {string} totalPrice - Total price of all bundle.
   */
  updateDiscountItem(totalPrice) {
    document.querySelectorAll('[js-discount-tracker="slide"]').forEach((item) => {
      const priceToUnlock = parseFloat(item.dataset.priceToUnlock.replace(/,/g, ''));
      const amountLeft = (priceToUnlock - totalPrice).toFixed(2);

      item.querySelector('[js-discount-tracker="amount-left"]').innerHTML = `
        ${window.bundleDrawerStrings.moneyFormat}${amountLeft > 0 ? amountLeft : 0}
      `;

      if (totalPrice >= priceToUnlock) {
        this.updateBundleItemCircle(item, totalPrice, totalPrice);
        this.applyDiscount(item.dataset.discountPercentage, totalPrice);
        item.querySelector('[js-discount-tracker="spend"]').classList.add('hidden');
        item.querySelector('[js-discount-tracker="discount_applied"]').classList.remove('hidden');
      } else {
        this.updateBundleItemCircle(item, item.dataset.priceToUnlock, totalPrice);
        item.querySelector('[js-discount-tracker="spend"]').classList.remove('hidden');
        item.querySelector('[js-discount-tracker="discount_applied"]').classList.add('hidden');
      }
    });
  }

  /**
   * Apply discount amount.
   * @param {string} discount - Discount.
   * @param {string} totalPrice - Total price of all bundle.
   */
  applyDiscount(discount, totalPrice) {
    document.querySelector('[js-basket-bar="discount"]').innerHTML = `
      ${window.bundleDrawerStrings.moneyFormat}
      ${(totalPrice * (discount / 100)).toFixed(2)}
    `;
  }

  /**
   * Clear the discount display.
   */
  clearDiscount() {
    document.querySelector('[js-basket-bar="discount"]').innerHTML = `
      ${window.bundleDrawerStrings.moneyFormat}0.00
    `;
  }

  /**
   * Update circle svg image.
   */
  updateBundleItemCircle(item, total, spent) {
    total = parseFloat(total.toString().replace(/,/g, ''));
    spent = parseFloat(spent.toString().replace(/,/g, ''));
    const circle = item.querySelector('[js-discount-tracker="progress"]');
    const radius = circle.r.baseVal.value;
    const circumference = 2 * Math.PI * radius;
    circle.style.strokeDasharray = `${circumference} ${circumference}`;
    circle.style.strokeDashoffset = circumference - (spent / total) * circumference;
  }

  stickyBar() {
    const basketBar = document.querySelector('[js-bundle-basket-bar="container"]');

    if (this.initialBasketBarTop === null) {
      return;
    }

    if (window.scrollY < this.initialBasketBarTop) {
      basketBar.classList.remove('is-fixed');
      return;
    }

    basketBar.classList.add('is-fixed');
  }
}

customElements.define('bundle-basket-bar', BundleBasketBar);
